module.exports = __webpack_public_path__ + "img/52002758_L.2f232713.png";